module.exports = __webpack_public_path__ + "img/black_ham_menu.802cbb1d.svg";